import { ArrowCounterClockwiseIcon, TrashIcon } from '@phosphor-icons/react';
import { Document, KnowledgebaseSource } from '../../../../Types';
import { RootState, useAppSelector } from '../../../../store';


function FileListItem({document, handleReembedDocument, source, handleRemoveExistingDocument}: {document: Document, handleReembedDocument: (identifier: string) => void, source: KnowledgebaseSource, handleRemoveExistingDocument: (sourceIdentifier: string, documentIdentifier: string) => void}) {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);

    return (
        <div
            key={document.identifier}
            className={'flex my-2 items-center justify-between bg-input-backgroundColor rounded-lg px-4 py-3 w-full'}
        >
            <span className="text-sm flex-grow">{document.filename}</span>
            <div className="flex items-center gap-3">
                <div
                    className={`w-3 h-3 rounded-full tooltip ${
                        document.status === 'in_progress'
                            ? 'bg-orange-400'
                            : document.status === 'error'
                            ? 'bg-red-500'
                            : 'bg-green-500'
                    }`}
                    data-tooltip-content={i18n.translate({
                        id: 'document.status.' + document.status,
                        fallback: document.status,
                        sourceName: 'Knowledgebase',
                    })}
                />
                {document.status==="error" && (
                    <button
                        onClick={() => handleReembedDocument(document.identifier)}
                        className="text-gray-500 hover:text-gray-700 tooltip"
                        data-tooltip-content={i18n.translate({
                            id: 'reembed',
                            sourceName: 'Knowledgebase',
                        })}
                    >
                        <ArrowCounterClockwiseIcon size={16} />
                    </button>
                )}
                {source.type === 'manual' && (
                    <button
                        onClick={() => handleRemoveExistingDocument(source.id, document.identifier)}
                        className="text-gray-500 hover:text-gray-700 tooltip"
                        data-tooltip-content={i18n.translate({
                            id: 'delete.button',
                            sourceName: 'Knowledgebase',
                        })}
                    >
                        <TrashIcon size={16} />
                    </button>
                )}
            </div>
        </div>
    );
}

export default FileListItem;
